var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('card',[_c('async-world-map',{staticClass:"map map-big",attrs:{"data":_vm.mapData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }